import Action from '../Action';
import BankUserService from '../../services/BankUserService';
import { message } from 'antd';

export function fetchBanks() {
	return (dispatch) => {
		BankUserService.getBanks()
			.then((banks) => dispatch({ type: Action.FETCH_BANKS, banks: banks.data }))
			.catch((error) => message.error('Failed to fetch forms!'));
	};
}

export function fetchBankUsers() {
	return (dispatch) => {
		BankUserService.getBankUsers()
			.then((bankUsers) => dispatch({ type: Action.FETCH_BANK_USERS, bankUsers: bankUsers.data }))
			.catch((error) => message.error('Failed to fetch users!'));
	};
}

export function addBankUser(body) {
	return (dispatch) => {
		BankUserService.add(body)
			.then((bankUser) => {
				dispatch({ type: Action.POST_BANK_USER, bankUser: bankUser.data });
				message.success('User Added');
			})
			.catch((error) => message.error('Failed to add user!'));
	};
}

export function updateBankUser(id, body) {
	return (dispatch) => {
		BankUserService.update(id, body)
			.then((bankUser) => {
				dispatch({ type: Action.UPDATE_BANK_USER, bankUser: bankUser.data });
				message.success('User Updated');
			})
			.catch((error) => message.error('Failed to edit user!'));
	};
}

export function deleteBankUser(id) {
	return (dispatch) => {
		BankUserService.delete(id)
			.then((bankUser) => {
				dispatch({ type: Action.DELETE_BANK_USER, bankUser: bankUser.data });
				message.success('User Deleted');
			})
			.catch((error) => message.error('Failed to delete user!'));
	};
}

export function updateBankUserPassword(id, body) {
	return (dispatch) => {
		BankUserService.resetPassword(id, body)
			.then((bankUser) => {
				dispatch({ type: Action.UPDATE_BANK_USER_PASSWORD, bankUser: bankUser.data });
				message.success('Password Updated');
			})
			.catch((error) => message.error('Failed to edit password!'));
	};
}

export function updateBankUserStatus(id, body) {
	return (dispatch) => {
		BankUserService.updateStatus(id, body)
			.then((bankUser) => {
				dispatch({ type: Action.UPDATE_BANK_USER_STATUS, bankUser: bankUser.data });
				message.success('Status Updated');
			})
			.catch((error) => message.error('Failed to edit status!'));
	};
}
